import { distance as levenshtein } from 'fastest-levenshtein';
import { GlobalLocaleStore } from 'services/base/i18n';

export enum CountryCode {
  AF = 'AF',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BA = 'BA',
  BW = 'BW',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  CV = 'CV',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  HR = 'HR',
  CU = 'CU',
  CY = 'CY',
  CZ = 'CZ',
  CI = 'CI',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  SZ = 'SZ',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MG = 'MG',
  MW = 'MW',
  MY = 'MY',
  MV = 'MV',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MK = 'MK',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  RE = 'RE',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TH = 'TH',
  TL = 'TL',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  GB = 'GB',
  US = 'US',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
}

export type CountryDetails = {
  code: CountryCode;
  dialCode: string;
  baseName: string;
};

export const countries: CountryDetails[] = [
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Afghanistan",
    dialCode: '+93',
    code: CountryCode.AF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Albania",
    dialCode: '+355',
    code: CountryCode.AL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Algeria",
    dialCode: '+213',
    code: CountryCode.DZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "American Samoa",
    dialCode: '+1 684',
    code: CountryCode.AS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Andorra",
    dialCode: '+376',
    code: CountryCode.AD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Angola",
    dialCode: '+244',
    code: CountryCode.AO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Anguilla",
    dialCode: '+1 264',
    code: CountryCode.AI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Antigua and Barbuda",
    dialCode: '+1268',
    code: CountryCode.AG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Argentina",
    dialCode: '+54',
    code: CountryCode.AR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Armenia",
    dialCode: '+374',
    code: CountryCode.AM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Aruba",
    dialCode: '+297',
    code: CountryCode.AW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Australia",
    dialCode: '+61',
    code: CountryCode.AU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Austria",
    dialCode: '+43',
    code: CountryCode.AT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Azerbaijan",
    dialCode: '+994',
    code: CountryCode.AZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bahamas",
    dialCode: '+1 242',
    code: CountryCode.BS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bahrain",
    dialCode: '+973',
    code: CountryCode.BH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bangladesh",
    dialCode: '+880',
    code: CountryCode.BD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Barbados",
    dialCode: '+1 246',
    code: CountryCode.BB,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Belarus",
    dialCode: '+375',
    code: CountryCode.BY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Belgium",
    dialCode: '+32',
    code: CountryCode.BE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Belize",
    dialCode: '+501',
    code: CountryCode.BZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Benin",
    dialCode: '+229',
    code: CountryCode.BJ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bermuda",
    dialCode: '+1 441',
    code: CountryCode.BM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bhutan",
    dialCode: '+975',
    code: CountryCode.BT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bolivia (Plurinational State of)",
    dialCode: '+591',
    code: CountryCode.BO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bosnia and Herzegovina",
    dialCode: '+387',
    code: CountryCode.BA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Botswana",
    dialCode: '+267',
    code: CountryCode.BW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Brazil",
    dialCode: '+55',
    code: CountryCode.BR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "British Indian Ocean Territory",
    dialCode: '+246',
    code: CountryCode.IO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Brunei Darussalam",
    dialCode: '+673',
    code: CountryCode.BN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Bulgaria",
    dialCode: '+359',
    code: CountryCode.BG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Burkina Faso",
    dialCode: '+226',
    code: CountryCode.BF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Burundi",
    dialCode: '+257',
    code: CountryCode.BI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cabo Verde",
    dialCode: '+238',
    code: CountryCode.CV,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cambodia",
    dialCode: '+855',
    code: CountryCode.KH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cameroon",
    dialCode: '+237',
    code: CountryCode.CM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Canada",
    dialCode: '+1',
    code: CountryCode.CA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cayman Islands",
    dialCode: '+345',
    code: CountryCode.KY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Central African Republic",
    dialCode: '+236',
    code: CountryCode.CF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Chad",
    dialCode: '+235',
    code: CountryCode.TD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Chile",
    dialCode: '+56',
    code: CountryCode.CL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "China",
    dialCode: '+86',
    code: CountryCode.CN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Christmas Island",
    dialCode: '+61',
    code: CountryCode.CX,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cocos (Keeling) Islands",
    dialCode: '+61',
    code: CountryCode.CC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Colombia",
    dialCode: '+57',
    code: CountryCode.CO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Comoros",
    dialCode: '+269',
    code: CountryCode.KM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Congo",
    dialCode: '+242',
    code: CountryCode.CG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Congo, Democratic Republic of the",
    dialCode: '+243',
    code: CountryCode.CD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cook Islands",
    dialCode: '+682',
    code: CountryCode.CK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Costa Rica",
    dialCode: '+506',
    code: CountryCode.CR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Croatia",
    dialCode: '+385',
    code: CountryCode.HR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cuba",
    dialCode: '+53',
    code: CountryCode.CU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Cyprus",
    dialCode: '+537',
    code: CountryCode.CY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Czechia",
    dialCode: '+420',
    code: CountryCode.CZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Côte d'Ivoire",
    dialCode: '+225',
    code: CountryCode.CI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Denmark",
    dialCode: '+45',
    code: CountryCode.DK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Djibouti",
    dialCode: '+253',
    code: CountryCode.DJ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Dominica",
    dialCode: '+1 767',
    code: CountryCode.DM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Dominican Republic",
    dialCode: '+1 849',
    code: CountryCode.DO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Ecuador",
    dialCode: '+593',
    code: CountryCode.EC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Egypt",
    dialCode: '+20',
    code: CountryCode.EG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "El Salvador",
    dialCode: '+503',
    code: CountryCode.SV,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Equatorial Guinea",
    dialCode: '+240',
    code: CountryCode.GQ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Eritrea",
    dialCode: '+291',
    code: CountryCode.ER,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Estonia",
    dialCode: '+372',
    code: CountryCode.EE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Eswatini",
    dialCode: '+268',
    code: CountryCode.SZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Ethiopia",
    dialCode: '+251',
    code: CountryCode.ET,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Falkland Islands (Malvinas)",
    dialCode: '+500',
    code: CountryCode.FK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Faroe Islands",
    dialCode: '+298',
    code: CountryCode.FO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Fiji",
    dialCode: '+679',
    code: CountryCode.FJ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Finland",
    dialCode: '+358',
    code: CountryCode.FI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "France",
    dialCode: '+33',
    code: CountryCode.FR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "French Guiana",
    dialCode: '+594',
    code: CountryCode.GF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "French Polynesia",
    dialCode: '+689',
    code: CountryCode.PF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Gabon",
    dialCode: '+241',
    code: CountryCode.GA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Gambia",
    dialCode: '+220',
    code: CountryCode.GM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Georgia",
    dialCode: '+995',
    code: CountryCode.GE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Germany",
    dialCode: '+49',
    code: CountryCode.DE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Ghana",
    dialCode: '+233',
    code: CountryCode.GH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Gibraltar",
    dialCode: '+350',
    code: CountryCode.GI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Greece",
    dialCode: '+30',
    code: CountryCode.GR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Greenland",
    dialCode: '+299',
    code: CountryCode.GL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Grenada",
    dialCode: '+1 473',
    code: CountryCode.GD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guadeloupe",
    dialCode: '+590',
    code: CountryCode.GP,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guam",
    dialCode: '+1 671',
    code: CountryCode.GU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guatemala",
    dialCode: '+502',
    code: CountryCode.GT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guernsey",
    dialCode: '+44',
    code: CountryCode.GG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guinea",
    dialCode: '+224',
    code: CountryCode.GN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guinea-Bissau",
    dialCode: '+245',
    code: CountryCode.GW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Guyana",
    dialCode: '+595',
    code: CountryCode.GY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Haiti",
    dialCode: '+509',
    code: CountryCode.HT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Holy See",
    dialCode: '+379',
    code: CountryCode.VA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Honduras",
    dialCode: '+504',
    code: CountryCode.HN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Hong Kong",
    dialCode: '+852',
    code: CountryCode.HK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Hungary",
    dialCode: '+36',
    code: CountryCode.HU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Iceland",
    dialCode: '+354',
    code: CountryCode.IS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "India",
    dialCode: '+91',
    code: CountryCode.IN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Indonesia",
    dialCode: '+62',
    code: CountryCode.ID,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Iran (Islamic Republic of)",
    dialCode: '+98',
    code: CountryCode.IR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Iraq",
    dialCode: '+964',
    code: CountryCode.IQ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Ireland",
    dialCode: '+353',
    code: CountryCode.IE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Isle of Man",
    dialCode: '+44',
    code: CountryCode.IM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Israel",
    dialCode: '+972',
    code: CountryCode.IL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Italy",
    dialCode: '+39',
    code: CountryCode.IT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Jamaica",
    dialCode: '+1 876',
    code: CountryCode.JM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Japan",
    dialCode: '+81',
    code: CountryCode.JP,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Jersey",
    dialCode: '+44',
    code: CountryCode.JE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Jordan",
    dialCode: '+962',
    code: CountryCode.JO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Kazakhstan",
    dialCode: '+7 7',
    code: CountryCode.KZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Kenya",
    dialCode: '+254',
    code: CountryCode.KE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Kiribati",
    dialCode: '+686',
    code: CountryCode.KI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Korea, Democratic People's Republic of",
    dialCode: '+850',
    code: CountryCode.KP,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Korea, Republic of",
    dialCode: '+82',
    code: CountryCode.KR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Kuwait",
    dialCode: '+965',
    code: CountryCode.KW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Kyrgyzstan",
    dialCode: '+996',
    code: CountryCode.KG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Lao People's Democratic Republic",
    dialCode: '+856',
    code: CountryCode.LA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Latvia",
    dialCode: '+371',
    code: CountryCode.LV,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Lebanon",
    dialCode: '+961',
    code: CountryCode.LB,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Lesotho",
    dialCode: '+266',
    code: CountryCode.LS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Liberia",
    dialCode: '+231',
    code: CountryCode.LR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Libya",
    dialCode: '+218',
    code: CountryCode.LY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Liechtenstein",
    dialCode: '+423',
    code: CountryCode.LI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Lithuania",
    dialCode: '+370',
    code: CountryCode.LT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Luxembourg",
    dialCode: '+352',
    code: CountryCode.LU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Macao",
    dialCode: '+853',
    code: CountryCode.MO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Madagascar",
    dialCode: '+261',
    code: CountryCode.MG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Malawi",
    dialCode: '+265',
    code: CountryCode.MW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Malaysia",
    dialCode: '+60',
    code: CountryCode.MY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Maldives",
    dialCode: '+960',
    code: CountryCode.MV,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mali",
    dialCode: '+223',
    code: CountryCode.ML,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Malta",
    dialCode: '+356',
    code: CountryCode.MT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Marshall Islands",
    dialCode: '+692',
    code: CountryCode.MH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Martinique",
    dialCode: '+596',
    code: CountryCode.MQ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mauritania",
    dialCode: '+222',
    code: CountryCode.MR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mauritius",
    dialCode: '+230',
    code: CountryCode.MU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mayotte",
    dialCode: '+262',
    code: CountryCode.YT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mexico",
    dialCode: '+52',
    code: CountryCode.MX,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Micronesia (Federated States of)",
    dialCode: '+691',
    code: CountryCode.FM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Moldova, Republic of",
    dialCode: '+373',
    code: CountryCode.MD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Monaco",
    dialCode: '+377',
    code: CountryCode.MC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mongolia",
    dialCode: '+976',
    code: CountryCode.MN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Montenegro",
    dialCode: '+382',
    code: CountryCode.ME,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Montserrat",
    dialCode: '+1664',
    code: CountryCode.MS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Morocco",
    dialCode: '+212',
    code: CountryCode.MA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Mozambique",
    dialCode: '+258',
    code: CountryCode.MZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Myanmar",
    dialCode: '+95',
    code: CountryCode.MM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Namibia",
    dialCode: '+264',
    code: CountryCode.NA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Nauru",
    dialCode: '+674',
    code: CountryCode.NR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Nepal",
    dialCode: '+977',
    code: CountryCode.NP,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Netherlands",
    dialCode: '+31',
    code: CountryCode.NL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "New Caledonia",
    dialCode: '+687',
    code: CountryCode.NC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "New Zealand",
    dialCode: '+64',
    code: CountryCode.NZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Nicaragua",
    dialCode: '+505',
    code: CountryCode.NI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Niger",
    dialCode: '+227',
    code: CountryCode.NE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Nigeria",
    dialCode: '+234',
    code: CountryCode.NG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Niue",
    dialCode: '+683',
    code: CountryCode.NU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Norfolk Island",
    dialCode: '+672',
    code: CountryCode.NF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "North Macedonia",
    dialCode: '+389',
    code: CountryCode.MK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Northern Mariana Islands",
    dialCode: '+1 670',
    code: CountryCode.MP,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Norway",
    dialCode: '+47',
    code: CountryCode.NO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Oman",
    dialCode: '+968',
    code: CountryCode.OM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Pakistan",
    dialCode: '+92',
    code: CountryCode.PK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Palau",
    dialCode: '+680',
    code: CountryCode.PW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Palestine, State of",
    dialCode: '+970',
    code: CountryCode.PS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Panama",
    dialCode: '+507',
    code: CountryCode.PA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Papua New Guinea",
    dialCode: '+675',
    code: CountryCode.PG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Paraguay",
    dialCode: '+595',
    code: CountryCode.PY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Peru",
    dialCode: '+51',
    code: CountryCode.PE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Philippines",
    dialCode: '+63',
    code: CountryCode.PH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Pitcairn",
    dialCode: '+872',
    code: CountryCode.PN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Poland",
    dialCode: '+48',
    code: CountryCode.PL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Portugal",
    dialCode: '+351',
    code: CountryCode.PT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Puerto Rico",
    dialCode: '+1 939',
    code: CountryCode.PR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Qatar",
    dialCode: '+974',
    code: CountryCode.QA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Romania",
    dialCode: '+40',
    code: CountryCode.RO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Russian Federation",
    dialCode: '+7',
    code: CountryCode.RU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Rwanda",
    dialCode: '+250',
    code: CountryCode.RW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Réunion",
    dialCode: '+262',
    code: CountryCode.RE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saint Helena, Ascension and Tristan da Cunha",
    dialCode: '+290',
    code: CountryCode.SH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saint Kitts and Nevis",
    dialCode: '+1 869',
    code: CountryCode.KN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saint Lucia",
    dialCode: '+1 758',
    code: CountryCode.LC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saint Pierre and Miquelon",
    dialCode: '+508',
    code: CountryCode.PM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saint Vincent and the Grenadines",
    dialCode: '+1 784',
    code: CountryCode.VC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Samoa",
    dialCode: '+685',
    code: CountryCode.WS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "San Marino",
    dialCode: '+378',
    code: CountryCode.SM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Sao Tome and Principe",
    dialCode: '+239',
    code: CountryCode.ST,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Saudi Arabia",
    dialCode: '+966',
    code: CountryCode.SA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Senegal",
    dialCode: '+221',
    code: CountryCode.SN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Serbia",
    dialCode: '+381',
    code: CountryCode.RS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Seychelles",
    dialCode: '+248',
    code: CountryCode.SC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Sierra Leone",
    dialCode: '+232',
    code: CountryCode.SL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Singapore",
    dialCode: '+65',
    code: CountryCode.SG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Slovakia",
    dialCode: '+421',
    code: CountryCode.SK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Slovenia",
    dialCode: '+386',
    code: CountryCode.SI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Solomon Islands",
    dialCode: '+677',
    code: CountryCode.SB,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Somalia",
    dialCode: '+252',
    code: CountryCode.SO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "South Africa",
    dialCode: '+27',
    code: CountryCode.ZA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "South Georgia and the South Sandwich Islands",
    dialCode: '+500',
    code: CountryCode.GS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "South Sudan",
    dialCode: '+211',
    code: CountryCode.SS,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Spain",
    dialCode: '+34',
    code: CountryCode.ES,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Sri Lanka",
    dialCode: '+94',
    code: CountryCode.LK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Sudan",
    dialCode: '+249',
    code: CountryCode.SD,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Suriname",
    dialCode: '+597',
    code: CountryCode.SR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Svalbard and Jan Mayen",
    dialCode: '+47',
    code: CountryCode.SJ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Sweden",
    dialCode: '+46',
    code: CountryCode.SE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Switzerland",
    dialCode: '+41',
    code: CountryCode.CH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Syrian Arab Republic",
    dialCode: '+963',
    code: CountryCode.SY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Taiwan",
    dialCode: '+886',
    code: CountryCode.TW,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tajikistan",
    dialCode: '+992',
    code: CountryCode.TJ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tanzania, United Republic of",
    dialCode: '+255',
    code: CountryCode.TZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Thailand",
    dialCode: '+66',
    code: CountryCode.TH,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Timor-Leste",
    dialCode: '+670',
    code: CountryCode.TL,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Togo",
    dialCode: '+228',
    code: CountryCode.TG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tokelau",
    dialCode: '+690',
    code: CountryCode.TK,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tonga",
    dialCode: '+676',
    code: CountryCode.TO,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Trinidad and Tobago",
    dialCode: '+1 868',
    code: CountryCode.TT,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tunisia",
    dialCode: '+216',
    code: CountryCode.TN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Türkiye",
    dialCode: '+90',
    code: CountryCode.TR,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Turkmenistan",
    dialCode: '+993',
    code: CountryCode.TM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Turks and Caicos Islands",
    dialCode: '+1 649',
    code: CountryCode.TC,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Tuvalu",
    dialCode: '+688',
    code: CountryCode.TV,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Uganda",
    dialCode: '+256',
    code: CountryCode.UG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Ukraine",
    dialCode: '+380',
    code: CountryCode.UA,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "United Arab Emirates",
    dialCode: '+971',
    code: CountryCode.AE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "United Kingdom of Great Britain and Northern Ireland",
    dialCode: '+44',
    code: CountryCode.GB,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "United States of America",
    dialCode: '+1',
    code: CountryCode.US,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Uruguay",
    dialCode: '+598',
    code: CountryCode.UY,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Uzbekistan",
    dialCode: '+998',
    code: CountryCode.UZ,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Vanuatu",
    dialCode: '+678',
    code: CountryCode.VU,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Venezuela (Bolivarian Republic of)",
    dialCode: '+58',
    code: CountryCode.VE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Viet Nam",
    dialCode: '+84',
    code: CountryCode.VN,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Virgin Islands (British)",
    dialCode: '+1 284',
    code: CountryCode.VG,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Virgin Islands (U.S.)",
    dialCode: '+1 340',
    code: CountryCode.VI,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Wallis and Futuna",
    dialCode: '+681',
    code: CountryCode.WF,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Yemen",
    dialCode: '+967',
    code: CountryCode.YE,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Zambia",
    dialCode: '+260',
    code: CountryCode.ZM,
  },
  {
    // eslint-disable-next-line @typescript-eslint/quotes
    baseName: "Zimbabwe",
    dialCode: '+263',
    code: CountryCode.ZW,
  },
];

export type CountryLocales = {
  code: CountryCode;
  en_US: string;
  ja_JP: string;
  zh_TW: string;
};

export const locales: CountryLocales[] = [
  {
    code: CountryCode.AF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Afghanistan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アフガニスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿富汗",
  },
  {
    code: CountryCode.AL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Albania",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アルバニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿爾巴尼亞",
  },
  {
    code: CountryCode.DZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Algeria",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アルジェリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿爾及利亞",
  },
  {
    code: CountryCode.AS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "American Samoa",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アメリカ領サモア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "美屬薩摩亞",
  },
  {
    code: CountryCode.AD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Andorra",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アンドラ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "安道爾",
  },
  {
    code: CountryCode.AO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Angola",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アンゴラ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "安哥拉",
  },
  {
    code: CountryCode.AI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Anguilla",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アンギラ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "安圭拉",
  },
  {
    code: CountryCode.AG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Antigua and Barbuda",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アンティグア・バーブーダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "安提瓜和巴布達",
  },
  {
    code: CountryCode.AR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Argentina",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アルゼンチン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿根廷",
  },
  {
    code: CountryCode.AM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Armenia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アルメニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "亞美尼亞",
  },
  {
    code: CountryCode.AW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Aruba",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アルバ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿魯巴",
  },
  {
    code: CountryCode.AU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Australia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "オーストラリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "澳大利亞",
  },
  {
    code: CountryCode.AT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Austria",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "オーストリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "奧地利",
  },
  {
    code: CountryCode.AZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Azerbaijan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アゼルバイジャン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿塞拜疆",
  },
  {
    code: CountryCode.BS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bahamas",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バハマ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴哈馬",
  },
  {
    code: CountryCode.BH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bahrain",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バーレーン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴林",
  },
  {
    code: CountryCode.BD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bangladesh",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バングラデシュ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "孟加拉國",
  },
  {
    code: CountryCode.BB,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Barbados",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バルバドス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴巴多斯",
  },
  {
    code: CountryCode.BY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Belarus",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベラルーシ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "白俄羅斯",
  },
  {
    code: CountryCode.BE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Belgium",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベルギー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "比利時",
  },
  {
    code: CountryCode.BZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Belize",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベリーズ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "伯利茲",
  },
  {
    code: CountryCode.BJ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Benin",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベナン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "貝寧",
  },
  {
    code: CountryCode.BM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bermuda",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バミューダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "百慕大",
  },
  {
    code: CountryCode.BT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bhutan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブータン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "不丹",
  },
  {
    code: CountryCode.BO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bolivia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ボリビア多民族国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "玻利維亞",
  },
  {
    code: CountryCode.BA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bosnia and Herzegovina",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ボスニア・ヘルツェゴビナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "波黑",
  },
  {
    code: CountryCode.BW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Botswana",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ボツワナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "博茨瓦納",
  },
  {
    code: CountryCode.BR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Brazil",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブラジル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴西",
  },
  {
    code: CountryCode.IO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "British Indian Ocean Territory",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イギリス領インド洋地域",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "英屬印度洋領地",
  },
  {
    code: CountryCode.BN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Brunei Darussalam",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブルネイ・ダルサラーム",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "文萊",
  },
  {
    code: CountryCode.BG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Bulgaria",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブルガリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "保加利亞",
  },
  {
    code: CountryCode.BF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Burkina Faso",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブルキナファソ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "布基納法索",
  },
  {
    code: CountryCode.BI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Burundi",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ブルンジ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "布隆迪",
  },
  {
    code: CountryCode.CV,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cape Verde",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カーボベルデ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "佛得角",
  },
  {
    code: CountryCode.KH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cambodia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カンボジア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "柬埔寨",
  },
  {
    code: CountryCode.CM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cameroon",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カメルーン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "喀麥隆",
  },
  {
    code: CountryCode.CA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Canada",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カナダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "加拿大",
  },
  {
    code: CountryCode.KY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cayman Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ケイマン諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "開曼群島",
  },
  {
    code: CountryCode.CF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Central African Republic",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "中央アフリカ共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "中非",
  },
  {
    code: CountryCode.TD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Chad",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "チャド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "乍得",
  },
  {
    code: CountryCode.CL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Chile",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "チリ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "智利",
  },
  {
    code: CountryCode.CN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "China",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "中国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "中國",
  },
  {
    code: CountryCode.CX,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Christmas Island",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "クリスマス島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖誕島",
  },
  {
    code: CountryCode.CC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cocos (Keeling) Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ココス（キーリング）諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "科科斯（基林）群島",
  },
  {
    code: CountryCode.CO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Colombia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コロンビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "哥倫比亞",
  },
  {
    code: CountryCode.KM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Comoros",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コモロ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "科摩羅",
  },
  {
    code: CountryCode.CG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Republic of the Congo",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コンゴ共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "剛果（布）",
  },
  {
    code: CountryCode.CD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Democratic Republic of the Congo",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コンゴ民主共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "剛果（金）",
  },
  {
    code: CountryCode.CK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cook Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "クック諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "庫克群島",
  },
  {
    code: CountryCode.CR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Costa Rica",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コスタリカ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "哥斯達黎加",
  },
  {
    code: CountryCode.HR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Croatia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "クロアチア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "克羅地亞",
  },
  {
    code: CountryCode.CU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cuba",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "キューバ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "古巴",
  },
  {
    code: CountryCode.CY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cyprus",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "キプロス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塞浦路斯",
  },
  {
    code: CountryCode.CZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Czech Republic",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "チェコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "捷克",
  },
  {
    code: CountryCode.CI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Cote D'Ivoire",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "コートジボワール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "科特迪瓦",
  },
  {
    code: CountryCode.DK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Denmark",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "デンマーク",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "丹麥",
  },
  {
    code: CountryCode.DJ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Djibouti",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジブチ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "吉布提",
  },
  {
    code: CountryCode.DM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Dominica",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ドミニカ国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "多米尼克",
  },
  {
    code: CountryCode.DO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Dominican Republic",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ドミニカ共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "多米尼加",
  },
  {
    code: CountryCode.EC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Ecuador",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エクアドル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "厄瓜多爾",
  },
  {
    code: CountryCode.EG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Egypt",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エジプト",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "埃及",
  },
  {
    code: CountryCode.SV,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "El Salvador",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エルサルバドル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "薩爾瓦多",
  },
  {
    code: CountryCode.GQ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Equatorial Guinea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "赤道ギニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "赤道幾內亞",
  },
  {
    code: CountryCode.ER,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Eritrea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エリトリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "厄立特里亞",
  },
  {
    code: CountryCode.EE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Estonia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エストニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "愛沙尼亞",
  },
  {
    code: CountryCode.SZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Eswatini",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スワジランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斯威士蘭",
  },
  {
    code: CountryCode.ET,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Ethiopia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "エチオピア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "埃塞俄比亞",
  },
  {
    code: CountryCode.FK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Falkland Islands (Malvinas)",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フォークランド（マルビナス）諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "福克蘭群島",
  },
  {
    code: CountryCode.FO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Faroe Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フェロー諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "法羅群島",
  },
  {
    code: CountryCode.FJ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Fiji",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フィジー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斐濟",
  },
  {
    code: CountryCode.FI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Finland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フィンランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "芬蘭",
  },
  {
    code: CountryCode.FR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "France",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フランス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "法國",
  },
  {
    code: CountryCode.GF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "French Guiana",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フランス領ギアナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "法屬圭亞那",
  },
  {
    code: CountryCode.PF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "French Polynesia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フランス領ポリネシア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "法屬波利尼西亞",
  },
  {
    code: CountryCode.GA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Gabon",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ガボン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "加蓬",
  },
  {
    code: CountryCode.GM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Republic of The Gambia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ガンビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "岡比亞",
  },
  {
    code: CountryCode.GE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Georgia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジョージア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "格魯吉亞",
  },
  {
    code: CountryCode.DE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Germany",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ドイツ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "德國",
  },
  {
    code: CountryCode.GH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Ghana",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ガーナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "加納",
  },
  {
    code: CountryCode.GI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Gibraltar",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジブラルタル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "直布羅陀",
  },
  {
    code: CountryCode.GR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Greece",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ギリシャ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "希臘",
  },
  {
    code: CountryCode.GL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Greenland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "グリーンランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "格陵蘭",
  },
  {
    code: CountryCode.GD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Grenada",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "グレナダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "格林納達",
  },
  {
    code: CountryCode.GP,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guadeloupe",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "グアドループ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瓜德羅普",
  },
  {
    code: CountryCode.GU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guam",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "グアム",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "關島",
  },
  {
    code: CountryCode.GT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guatemala",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "グアテマラ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "危地馬拉",
  },
  {
    code: CountryCode.GG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guernsey",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ガーンジー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "根西",
  },
  {
    code: CountryCode.GN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guinea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ギニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "幾內亞",
  },
  {
    code: CountryCode.GW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guinea-Bissau",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ギニアビサウ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "幾內亞比紹",
  },
  {
    code: CountryCode.GY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Guyana",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ガイアナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "圭亞那",
  },
  {
    code: CountryCode.HT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Haiti",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ハイチ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "海地",
  },
  {
    code: CountryCode.VA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Holy See (Vatican City State)",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バチカン市国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "梵蒂岡",
  },
  {
    code: CountryCode.HN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Honduras",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ホンジュラス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "洪都拉斯",
  },
  {
    code: CountryCode.HK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Hong Kong",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "香港",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "香港",
  },
  {
    code: CountryCode.HU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Hungary",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ハンガリー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "匈牙利",
  },
  {
    code: CountryCode.IS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Iceland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アイスランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "冰島",
  },
  {
    code: CountryCode.IN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "India",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "インド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "印度",
  },
  {
    code: CountryCode.ID,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Indonesia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "インドネシア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "印尼",
  },
  {
    code: CountryCode.IR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Islamic Republic of Iran",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イラン・イスラム共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "伊朗",
  },
  {
    code: CountryCode.IQ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Iraq",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イラク",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "伊拉克",
  },
  {
    code: CountryCode.IE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Ireland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アイルランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "愛爾蘭",
  },
  {
    code: CountryCode.IM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Isle of Man",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マン島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬恩島",
  },
  {
    code: CountryCode.IL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Israel",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イスラエル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "以色列",
  },
  {
    code: CountryCode.IT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Italy",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イタリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "意大利",
  },
  {
    code: CountryCode.JM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Jamaica",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジャマイカ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "牙買加",
  },
  {
    code: CountryCode.JP,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Japan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "日本",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "日本",
  },
  {
    code: CountryCode.JE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Jersey",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジャージー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "澤西",
  },
  {
    code: CountryCode.JO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Jordan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ヨルダン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "約旦",
  },
  {
    code: CountryCode.KZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Kazakhstan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カザフスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "哈薩克斯坦",
  },
  {
    code: CountryCode.KE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Kenya",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ケニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "肯尼亞",
  },
  {
    code: CountryCode.KI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Kiribati",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "キリバス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "基里巴斯",
  },
  {
    code: CountryCode.KP,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "North Korea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "朝鮮民主主義人民共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "朝鮮",
  },
  {
    code: CountryCode.KR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "South Korea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "大韓民国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "韓國",
  },
  {
    code: CountryCode.KW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Kuwait",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "クウェート",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "科威特",
  },
  {
    code: CountryCode.KG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Kyrgyzstan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "キルギス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "吉爾吉斯斯坦",
  },
  {
    code: CountryCode.LA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Lao People's Democratic Republic",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ラオス人民民主共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "老撾",
  },
  {
    code: CountryCode.LV,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Latvia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ラトビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "拉脫維亞",
  },
  {
    code: CountryCode.LB,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Lebanon",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "レバノン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "黎巴嫩",
  },
  {
    code: CountryCode.LS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Lesotho",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "レソト",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "萊索托",
  },
  {
    code: CountryCode.LR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Liberia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "リベリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "利比里亞",
  },
  {
    code: CountryCode.LY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Libya",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "リビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "利比亞",
  },
  {
    code: CountryCode.LI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Liechtenstein",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "リヒテンシュタイン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "列支敦士登",
  },
  {
    code: CountryCode.LT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Lithuania",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "リトアニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "立陶宛",
  },
  {
    code: CountryCode.LU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Luxembourg",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ルクセンブルク",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "盧森堡",
  },
  {
    code: CountryCode.MO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Macao",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マカオ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "澳門",
  },
  {
    code: CountryCode.MG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Madagascar",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マダガスカル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬達加斯加",
  },
  {
    code: CountryCode.MW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Malawi",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マラウイ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬拉維",
  },
  {
    code: CountryCode.MY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Malaysia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マレーシア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬來西亞",
  },
  {
    code: CountryCode.MV,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Maldives",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モルディブ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬爾代夫",
  },
  {
    code: CountryCode.ML,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mali",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マリ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬里",
  },
  {
    code: CountryCode.MT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Malta",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マルタ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬耳他",
  },
  {
    code: CountryCode.MH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Marshall Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マーシャル諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬紹爾群島",
  },
  {
    code: CountryCode.MQ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Martinique",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マルティニーク",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬提尼克",
  },
  {
    code: CountryCode.MR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mauritania",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モーリタニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "毛里塔尼亞",
  },
  {
    code: CountryCode.MU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mauritius",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モーリシャス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "毛里求斯",
  },
  {
    code: CountryCode.YT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mayotte",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "マヨット",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "馬約特",
  },
  {
    code: CountryCode.MX,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mexico",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "メキシコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "墨西哥",
  },
  {
    code: CountryCode.FM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Micronesia, Federated States of",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ミクロネシア連邦",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "密克羅尼西亞聯邦",
  },
  {
    code: CountryCode.MD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Moldova, Republic of",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モルドバ共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "摩爾多瓦",
  },
  {
    code: CountryCode.MC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Monaco",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モナコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "摩納哥",
  },
  {
    code: CountryCode.MN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mongolia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モンゴル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "蒙古",
  },
  {
    code: CountryCode.ME,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Montenegro",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モンテネグロ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "黑山",
  },
  {
    code: CountryCode.MS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Montserrat",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モントセラト",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "蒙特塞拉特",
  },
  {
    code: CountryCode.MA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Morocco",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モロッコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "摩洛哥",
  },
  {
    code: CountryCode.MZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Mozambique",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "モザンビーク",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "莫桑比克",
  },
  {
    code: CountryCode.MM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Myanmar",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ミャンマー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "緬甸",
  },
  {
    code: CountryCode.NA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Namibia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ナミビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "納米比亞",
  },
  {
    code: CountryCode.NR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Nauru",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ナウル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瑙魯",
  },
  {
    code: CountryCode.NP,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Nepal",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ネパール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "尼泊爾",
  },
  {
    code: CountryCode.NL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Netherlands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "オランダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "荷蘭",
  },
  {
    code: CountryCode.NC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "New Caledonia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ニューカレドニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "新喀裡多尼亞",
  },
  {
    code: CountryCode.NZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "New Zealand",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ニュージーランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "新西蘭",
  },
  {
    code: CountryCode.NI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Nicaragua",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ニカラグア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "尼加拉瓜",
  },
  {
    code: CountryCode.NE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Niger",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ニジェール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "尼日爾",
  },
  {
    code: CountryCode.NG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Nigeria",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ナイジェリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "尼日利亞",
  },
  {
    code: CountryCode.NU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Niue",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ニウエ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "紐埃",
  },
  {
    code: CountryCode.NF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Norfolk Island",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ノーフォーク島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "諾福克島",
  },
  {
    code: CountryCode.MK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "The Republic of North Macedonia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "北マケドニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "北馬其頓",
  },
  {
    code: CountryCode.MP,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Northern Mariana Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "北マリアナ諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "北馬里亞納群島",
  },
  {
    code: CountryCode.NO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Norway",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ノルウェー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "挪威",
  },
  {
    code: CountryCode.OM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Oman",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "オマーン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿曼",
  },
  {
    code: CountryCode.PK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Pakistan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パキスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴基斯坦",
  },
  {
    code: CountryCode.PW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Palau",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パラオ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "帕勞",
  },
  {
    code: CountryCode.PS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "State of Palestine",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パレスチナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴勒斯坦",
  },
  {
    code: CountryCode.PA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Panama",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パナマ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴拿馬",
  },
  {
    code: CountryCode.PG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Papua New Guinea",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パプアニューギニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴布亞新幾內亞",
  },
  {
    code: CountryCode.PY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Paraguay",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "パラグアイ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "巴拉圭",
  },
  {
    code: CountryCode.PE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Peru",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ペルー",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "秘魯",
  },
  {
    code: CountryCode.PH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Philippines",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "フィリピン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "菲律賓",
  },
  {
    code: CountryCode.PN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Pitcairn",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ピトケアン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "皮特凱恩群島",
  },
  {
    code: CountryCode.PL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Poland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ポーランド",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "波蘭",
  },
  {
    code: CountryCode.PT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Portugal",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ポルトガル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "葡萄牙",
  },
  {
    code: CountryCode.PR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Puerto Rico",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "プエルトリコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "波多黎各",
  },
  {
    code: CountryCode.QA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Qatar",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "カタール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "卡塔爾",
  },
  {
    code: CountryCode.RO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Romania",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ルーマニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "羅馬尼亞",
  },
  {
    code: CountryCode.RU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Russian Federation",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ロシア連邦",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "俄羅斯",
  },
  {
    code: CountryCode.RW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Rwanda",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ルワンダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "盧旺達",
  },
  {
    code: CountryCode.RE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Reunion",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "レユニオン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "留尼汪",
  },
  {
    code: CountryCode.SH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saint Helena",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セントヘレナ・アセンションおよびトリスタンダクーニャ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖赫勒拿、阿森松和特里斯坦-達庫尼亞",
  },
  {
    code: CountryCode.KN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saint Kitts and Nevis",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セントクリストファー・ネイビス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖基茨和尼維斯",
  },
  {
    code: CountryCode.LC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saint Lucia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セントルシア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖盧西亞",
  },
  {
    code: CountryCode.PM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saint Pierre and Miquelon",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サンピエール島・ミクロン島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖皮埃爾和密克隆",
  },
  {
    code: CountryCode.VC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saint Vincent and the Grenadines",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セントビンセントおよびグレナディーン諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖文森特和格林納丁斯",
  },
  {
    code: CountryCode.WS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Samoa",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サモア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "薩摩亞",
  },
  {
    code: CountryCode.SM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "San Marino",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サンマリノ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖馬力諾",
  },
  {
    code: CountryCode.ST,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Sao Tome and Principe",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サントメ・プリンシペ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "聖多美和普林西比",
  },
  {
    code: CountryCode.SA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Saudi Arabia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サウジアラビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "沙特阿拉伯",
  },
  {
    code: CountryCode.SN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Senegal",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セネガル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塞內加爾",
  },
  {
    code: CountryCode.RS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Serbia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セルビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塞爾維亞",
  },
  {
    code: CountryCode.SC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Seychelles",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "セーシェル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塞舌爾",
  },
  {
    code: CountryCode.SL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Sierra Leone",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "シエラレオネ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塞拉利昂",
  },
  {
    code: CountryCode.SG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Singapore",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "シンガポール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "新加坡",
  },
  {
    code: CountryCode.SK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Slovakia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スロバキア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斯洛伐克",
  },
  {
    code: CountryCode.SI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Slovenia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スロベニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斯洛文尼亞",
  },
  {
    code: CountryCode.SB,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Solomon Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ソロモン諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "所羅門群島",
  },
  {
    code: CountryCode.SO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Somalia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ソマリア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "索馬里",
  },
  {
    code: CountryCode.ZA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "South Africa",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "南アフリカ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "南非",
  },
  {
    code: CountryCode.GS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "South Georgia and the South Sandwich Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "サウスジョージア・サウスサンドウィッチ諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "南喬治亞和南桑威奇群島",
  },
  {
    code: CountryCode.SS,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "South Sudan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "南スーダン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "南蘇丹",
  },
  {
    code: CountryCode.ES,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Spain",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スペイン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "西班牙",
  },
  {
    code: CountryCode.LK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Sri Lanka",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スリランカ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斯里蘭卡",
  },
  {
    code: CountryCode.SD,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Sudan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スーダン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "蘇丹",
  },
  {
    code: CountryCode.SR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Suriname",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スリナム",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "蘇里南",
  },
  {
    code: CountryCode.SJ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Svalbard and Jan Mayen",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スヴァールバル諸島およびヤンマイエン島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "斯瓦爾巴和揚馬延",
  },
  {
    code: CountryCode.SE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Sweden",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スウェーデン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瑞典",
  },
  {
    code: CountryCode.CH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Switzerland",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "スイス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瑞士",
  },
  {
    code: CountryCode.SY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Syrian Arab Republic",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "シリア・アラブ共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "敘利亞",
  },
  {
    code: CountryCode.TW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Taiwan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "台湾",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "台灣",
  },
  {
    code: CountryCode.TJ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Tajikistan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "タジキスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "塔吉克斯坦",
  },
  {
    code: CountryCode.TZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "United Republic of Tanzania",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "タンザニア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "坦桑尼亞",
  },
  {
    code: CountryCode.TH,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Thailand",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "タイ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "泰國",
  },
  {
    code: CountryCode.TL,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Timor-Leste",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "東ティモール",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "東帝汶",
  },
  {
    code: CountryCode.TG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Togo",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トーゴ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "多哥",
  },
  {
    code: CountryCode.TK,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Tokelau",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トケラウ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "托克勞",
  },
  {
    code: CountryCode.TO,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Tonga",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トンガ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "湯加",
  },
  {
    code: CountryCode.TT,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Trinidad and Tobago",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トリニダード・トバゴ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "特立尼達和多巴哥",
  },
  {
    code: CountryCode.TN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Tunisia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "チュニジア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "突尼斯",
  },
  {
    code: CountryCode.TR,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Turkey",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トルコ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "土耳其",
  },
  {
    code: CountryCode.TM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Turkmenistan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "トルクメニスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "土庫曼斯坦",
  },
  {
    code: CountryCode.TC,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Turks and Caicos Islands",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "タークス・カイコス諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "特克斯和凱科斯群島",
  },
  {
    code: CountryCode.TV,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Tuvalu",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ツバル",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "圖瓦盧",
  },
  {
    code: CountryCode.UG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Uganda",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ウガンダ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "烏干達",
  },
  {
    code: CountryCode.UA,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Ukraine",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ウクライナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "烏克蘭",
  },
  {
    code: CountryCode.AE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "United Arab Emirates",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アラブ首長国連邦",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "阿聯酋",
  },
  {
    code: CountryCode.GB,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "United Kingdom",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イギリス",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "英國",
  },
  {
    code: CountryCode.US,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "United States of America",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アメリカ合衆国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "美國",
  },
  {
    code: CountryCode.UY,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Uruguay",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ウルグアイ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "烏拉圭",
  },
  {
    code: CountryCode.UZ,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Uzbekistan",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ウズベキスタン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "烏茲別克斯坦",
  },
  {
    code: CountryCode.VU,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Vanuatu",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "バヌアツ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瓦努阿圖",
  },
  {
    code: CountryCode.VE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Venezuela",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベネズエラ・ボリバル共和国",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "委內瑞拉",
  },
  {
    code: CountryCode.VN,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Vietnam",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ベトナム",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "越南",
  },
  {
    code: CountryCode.VG,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Virgin Islands, British",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イギリス領ヴァージン諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "英屬維爾京群島",
  },
  {
    code: CountryCode.VI,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Virgin Islands, U.S.",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "アメリカ領ヴァージン諸島",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "美屬維爾京群島",
  },
  {
    code: CountryCode.WF,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Wallis and Futuna",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ウォリス・フツナ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "瓦利斯和富圖納",
  },
  {
    code: CountryCode.YE,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Yemen",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "イエメン",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "也門",
  },
  {
    code: CountryCode.ZM,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Zambia",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ザンビア",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "贊比亞",
  },
  {
    code: CountryCode.ZW,
    // eslint-disable-next-line @typescript-eslint/quotes
    en_US: "Zimbabwe",
    // eslint-disable-next-line @typescript-eslint/quotes
    ja_JP: "ジンバブエ",
    // eslint-disable-next-line @typescript-eslint/quotes
    zh_TW: "津巴布韋",
  },
];

const countriesIndexedByDialCode = (() => {
  const result = new Map<string, number[]>();
  countries.forEach((country, index) => {
    const indexes = result.get(country.dialCode);
    if (indexes === undefined) {
      result.set(country.dialCode, [index]);
    } else {
      indexes.push(index);
    }
  });
  return result;
})();

export const getCountryByDialCode = (dialCode: string, baseName: string): CountryDetails | undefined => {
  const indexes = countriesIndexedByDialCode.get(dialCode);

  if (indexes === undefined || indexes.length === 0) return undefined;
  if (indexes.length === 1) return countries[indexes[0]];

  let minCountry = undefined;
  let minDistance = undefined;
  const baseNameLower = baseName.toLowerCase();
  for (const index of indexes) {
    const country = countries[index];
    const countryBaseNameLower = country.baseName.toLowerCase();
    const distance = levenshtein(baseNameLower, countryBaseNameLower);
    if (minDistance === undefined || distance < minDistance) {
      minCountry = country;
      minDistance = distance;
    }
  }

  return minCountry;
};

export const countriesIndexedByCode = new Map<CountryCode, number>(
  countries.map((country, index) => [country.code, index]));

export const getCountryByCode = (code: CountryCode): CountryDetails | undefined => {
  const index = countriesIndexedByCode.get(code);
  return index !== undefined ? countries[index] : undefined;
};

export const getLocalNameByCode = (code: CountryCode): string | undefined => {
  const index = countriesIndexedByCode.get(code);
  return index !== undefined ? locales[index][GlobalLocaleStore.get()] : undefined;
};
